import { Navigate } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";
import { InlineWidget } from "react-calendly";
import { H1 } from "@/components/ui/headings";
import { AppLayout } from "@/components/layout/AppLayout";

export const Appointments = () => {
  const { isAuthenticated } = useAuth0();

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <AppLayout>
      <div className="flex flex-col gap-4 mb-4 w-full xl:w-2/4">
        <H1>Appointments</H1>
        <p className="text-muted-foreground">
          We strongly encourage all clients on our Cognitive Health Program to
          make an Appointment in order to heighten their experience and
          customize their protocol. Please schedule an appointment using this
          form and our team will contact you with more details.
        </p>
      </div>
      <InlineWidget url="https://calendly.com/amosinstitute/50min" />
    </AppLayout>
  );
};
